<header class="header {{headerCSS}}">
  <nav class="navbar navbar-static-top navbar-expand-lg navbar-light header-sticky min-height">
    <navigation-dropdown *ngIf="user" [username]="user.userName" [navigations]="navigations">
    </navigation-dropdown>
    <div class="container-fluid">
      <div>
        <a class="navbar-brand" [routerLink]="['/home']">
          <img *ngIf="displayLogo == true" class="img-fluid" src="assets/images/logo.svg" alt="logo">
        </a>
      </div>
      <div *ngIf="displaySignIn == true" class="add-listing">
        <div *ngIf="!user">
          <div class="login d-inline-block mr-4">
            <a [routerLink]="['/signin']"><i class="far fa-user pr-2"></i>Sign in</a>
          </div>
          <a [routerLink]="['/signup']" class="btn btn-white btn-md"> <i class="fas fa-plus-circle"></i>Sign up</a>
        </div>
      </div>
    </div>
  </nav>
  <ng-content></ng-content>
</header>